"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilesUrl = exports.getRedirectToFilesLocation = exports.getProviderParam = void 0;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _Constants = require("../Constants");

var _Constants2 = require("FileManagerCore/Constants");

var getProviderParam = function getProviderParam(type) {
  if (type === _Constants.DrawerTypes.HUBL_VIDEO) {
    return {
      provider: _Constants2.VideoProviders.VIDYARD
    };
  }

  return {};
};

exports.getProviderParam = getProviderParam;

var getRedirectToFilesLocation = function getRedirectToFilesLocation() {
  return "/files/" + _PortalIdParser.default.get();
};
/**
  returns URL to the file manager dashboard app
**/


exports.getRedirectToFilesLocation = getRedirectToFilesLocation;

var getFilesUrl = function getFilesUrl() {
  return window.location.origin.concat(getRedirectToFilesLocation());
};

exports.getFilesUrl = getFilesUrl;